export { CurrencyCityTemplate } from "./CurrencyCityTemplate";
